export default theme => {
    return {}
}



// WEBPACK FOOTER //
// ./src/app/configuration/Max/theme/components/scorecard/MetricsLabels/index.js